import { render, staticRenderFns } from "./Protected.vue?vue&type=template&id=27562d3a&scoped=true&"
import script from "./Protected.vue?vue&type=script&lang=js&"
export * from "./Protected.vue?vue&type=script&lang=js&"
import style0 from "./Protected.vue?vue&type=style&index=0&id=27562d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27562d3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VRow,VTextField})
